import { TaskType } from '@shared/enums/task-type.enum';
import { EventSidenavController } from '@shared/modules/event-sidenav/controllers/event-sidenav.controller';
import { ChangesSidenavController } from '@shared/modules/task-sidenav/controllers/changes-sidenav.controller';
import { TaskSidenavController } from '@shared/modules/task-sidenav/controllers/task-sidenav.controller';
import { ProjectController } from '@modules/projects/shared/controllers/project.controller';
import { ContactController } from '@modules/contacts/shared/controllers/contact.controller';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { Component, inject } from '@angular/core';
import { DEFAULT_PANEL_ROLES } from '@shared/auth/enums/app-role.enum';
import { NotificationsService } from '@modules/notification/shared/services/notifications.service';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { UIModule } from '@shared/modules/ui/ui.module';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderActionMenuUserComponent } from './components/header-action-menu-user/header-action-menu-user.component';
import { HasRoleDirective } from '@shared/auth/directives/has-role.directive';

@Component({
  selector: 'header-action-menu',
  templateUrl: './header-action-menu.component.html',
  styleUrls: ['./header-action-menu.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    UIModule,
    TranslateModule,
    HeaderActionMenuUserComponent,
    HasRoleDirective
  ]
})
export class HeaderActionMenuComponent {
  ButtonSize = ButtonSize;
  ButtonTypes = ButtonTypes;
  TaskType = TaskType;
  protected readonly defaultPanelRoles = DEFAULT_PANEL_ROLES;

  public readonly notificationsService = inject(NotificationsService);

  createContact() {
    const ctrl = new ContactController();
    ctrl.add();
  }

  createProjectDraft() {
    const ctrl = new ProjectController();
    ctrl.add();
  }

  createTask(type: TaskType = TaskType.TYPE_TASK) {
    const ctrl = new TaskSidenavController();
    ctrl.addTask({ taskType: type });
  }

  createChange() {
    const ctrl = new ChangesSidenavController();
    ctrl.addChange(null);
  }

  createEvent() {
    const ctrl = new EventSidenavController();
    ctrl.createEvent();
  }

}
